import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { TRootState } from 'store/create-store';

export const useAppSelector: TypedUseSelectorHook<TRootState> = useSelector;
